<template>
    <md-card-content>
        <div class="md-layout">
            <div class="md-layout-item md-size-25">
                <md-field class="md-invalid">
                    <label>Numéro <span v-if="sameNumber" class="italic font-medium text-warning">(Numéro de contrat déjà utilisé)</span></label>
                    <md-input v-model="contract.number" name="number" type="text" required @blur="checkContractNumber"></md-input>
                    <validation-error :errors="apiValidationErrors.number"/>
                </md-field>
            </div>
            <div class="md-layout-item md-size-25">
                <md-field class="md-invalid">
                    <label>Durée d'engagement du contrat</label>
                    <md-select v-model="contract.periodRepetition" name="periodRepetition" id="periodRepetition">
                        <md-option :value="0">12 mois</md-option>
                        <md-option :value="1">24 mois</md-option>
                        <md-option :value="2">36 mois</md-option>
                        <md-option :value="3">48 mois</md-option>
                        <md-option :value="4">60 mois</md-option>
                        <md-option :value="6">72 mois</md-option>
                        <md-option :value="7">84 mois</md-option>
                        <md-option :value="8">96 mois</md-option>
                        <md-option :value="9">108 mois</md-option>
                        <md-option :value="10">120 mois</md-option>
                    </md-select>
                    <validation-error :errors="apiValidationErrors.period_repetition" />
                </md-field>
            </div>
			<div class="md-layout-item md-size-15">
				<md-field class="md-invalid">
					<label>Durée du préavis (en jours)</label>
					<md-input v-model="contract.daysNotice" type="number" required></md-input>
					<validation-error :errors="apiValidationErrors.days_notice" />
				</md-field>
			</div>
			<div class="md-layout-item md-size-15">
				<md-field class="md-invalid">
					<label>Pourcentage d'augmentation</label>
					<md-input v-model="contract.percentIncrease" type="text" required></md-input>
					<validation-error :errors="apiValidationErrors.percent_increase" />
				</md-field>
			</div>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-50">
                <md-field class="md-invalid">
                    <label>Facturation *</label>
                    <md-select v-model="contract.billingMonths" name="billingMonths" id="billingMonths" multiple>
                        <md-option value="0">Janvier</md-option>
                        <md-option value="1">Février</md-option>
                        <md-option value="2">Mars</md-option>
                        <md-option value="3">Avril</md-option>
                        <md-option value="4">Mai</md-option>
                        <md-option value="5">Juin</md-option>
                        <md-option value="6">Juillet</md-option>
                        <md-option value="7">Août</md-option>
                        <md-option value="8">Septembre</md-option>
                        <md-option value="9">Octobre</md-option>
                        <md-option value="10">Novembre</md-option>
                        <md-option value="11">Décembre</md-option>
                    </md-select>
                    <validation-error :errors="apiValidationErrors.billing_months" />
                </md-field>
            </div>
			<div class="md-layout-item md-size-25">
				<md-checkbox class="mt-4" v-model="contract.isTacit">Tacite reconduction</md-checkbox>
			</div>
        </div>
		<div class="md-layout mt-4">
			<div class="md-layout-item md-size-50">
				<md-field class="md-invalid">
					<label>Informations de facturation</label>
					<md-input v-model="contract.billingInfos" type="text"></md-input>
					<validation-error :errors="apiValidationErrors.billing_info" />
				</md-field>
			</div>
			<div class="md-layout-item md-size-10">
				<md-checkbox class="mt-4" v-model="contract.isSettingUp">Mise en place</md-checkbox>
			</div>
			<div class="md-layout-item md-size-40">
				<md-field class="md-invalid">
					<label>Commentaires de mise en place</label>
					<md-input v-model="contract.settingUpComment" type="text" :disabled="!contract.isSettingUp"></md-input>
					<validation-error :errors="apiValidationErrors.setting_up_comment" />
				</md-field>
			</div>
		</div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-50">
                <md-field class="md-invalid">
                    <label>Début de la relation avec le client</label>
                    <md-input v-model="contract.clientRelation" type="text"></md-input>
                    <validation-error :errors="apiValidationErrors.client_relation" />
                </md-field>
            </div>
			<div class="md-layout-item md-size-50">
				<md-field class="md-invalid">
					<label>Commentaires</label>
					<md-input v-model="contract.comment" type="text"></md-input>
					<validation-error :errors="apiValidationErrors.comment" />
				</md-field>
			</div>
        </div>
        <div class="pl-3.5 mt-4">
            <p class="font-bold mb-0 leading-none">Gestion des périodes</p>
            <small v-if="action === 'edit'" class="text-gray">La modification sur la durée des périodes n'impactera pas la période en cours. Celle-ci prendra effet pour les périodes futures.</small>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-15">
                <md-field class="md-invalid md-date">
                    <label>Durée des périodes (en mois)</label>
                    <md-input v-model="contract.periodDuration" type="number"></md-input>
                    <validation-error :errors="apiValidationErrors.period_duration" />
                </md-field>
            </div>
        </div>
		<div class="mt-4" v-if="action === 'add'">
			<p class="font-bold mb-0 leading-none pl-3.5">Création de la première période</p>
			<div class="md-layout mt-4">
				<div class="md-layout-item md-size-20">
					<div class="md-vdatepicker">
						<datetime v-model="contract.period.dateStart" type="date" auto :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }"
								  input-id="dateStart" placeholder="dd/mm/yyyy"
						>
							<label slot="before">Date de début de la première période</label>
						</datetime>
						<validation-error :errors="apiValidationErrors.date_start" />
					</div>
				</div>
				<div class="md-layout-item md-size-20">
					<div class="md-vdatepicker">
						<datetime v-model="contract.period.dateEnd" type="date" auto :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }"
								  input-id="dateEnd" placeholder="dd/mm/yyyy"
						>
							<label slot="before">Date de fin de la première période</label>
						</datetime>
						<validation-error :errors="apiValidationErrors.date_end" />
					</div>
				</div>
				<div class="md-layout-item md-size-15">
					<md-field class="md-invalid">
						<label>Montant prévu</label>
						<md-input v-model="contract.period.amount" type="text" required></md-input>
						<validation-error :errors="apiValidationErrors.amount" />
					</md-field>
				</div>
			</div>
		</div>
        <md-divider class="mt-4 mx-3.5"></md-divider>
        <div class="md-layout">
            <div class="md-layout-item md-size-50">
                <md-checkbox class="mt-4" v-model="contract.isActive">Contrat actif</md-checkbox>
            </div>
        </div>
        <div class="md-layout">
            <div class="md-layout-item md-size-100">
                <div class="block-alert danger mt-2" v-if="!isActive">
                    <p class="font-medium">Le contrat n'est pas actif ! Il n'est donc pas disponible dans la planification des interventions.</p>
                </div>
            </div>
        </div>
    </md-card-content>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "ContractForm",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    props: {
        contract: Object,
        action: String,
        errors: Array
    },
    data() {
        return {
            cancelTypes: [],
            isActive: _.cloneDeep(this.contract.isActive),
	        sameNumber: false
        }
    },
    methods: {
        async getCancelTypes() {
            const { data } = await this.$store.dispatch('contracts/getCancelTypes')
            this.cancelTypes = data
        },
	    async checkContractNumber() {
			const { data } = await this.$store.dispatch('contracts/checkContractNumber', {
				number: this.contract.number,
				site_id: this.$route.params.idSite
			})
		    this.sameNumber = !_.isEmpty(data)
	    }
    },
    mounted() {
        this.getCancelTypes()
    },
    watch: {
        errors: function (newVal) {
            this.resetApiValidation();
            if (newVal) {
                this.setApiValidation(newVal);
            }
        },
        'contract.period.cancelDate'(newVal) {
            if(!newVal) {
                this.contract.period.cancelTypeId = null
            }
        },
        'contract.period.dateStart'(newVal) {
            if(this.action === 'add') {
                if(newVal) {
                    this.contract.period.dateEnd = this.$moment(new Date(newVal)).add(this.contract.periodDuration, 'months').format('Y-MM-DD')
                }
            }
        },
        'contract.periodDuration'(newVal) {
            if(this.action === 'add') {
                document.getElementById('dateEnd').setAttribute('placeholder', this.$moment(new Date()).add(newVal, 'months').format('DD MMMM YYYY'))
                if(this.contract.period.dateEnd !== null) {
                    this.contract.period.dateEnd = this.$moment(new Date(this.contract.period.dateStart)).add(this.contract.periodDuration, 'months').format('Y-MM-DD')
                }
            }
        },
        'contract.isActive'(newVal) {
            this.isActive = _.cloneDeep(newVal)
        }
    }
}
</script>

<style scoped>

</style>
